import Breadcrumb from "../components/BreadCurmb";
import ContactFormTwo from "../components/ContactFormTwo";
import PriceTableOne from "../components/PriceTableOne";
import FooterOne from "../footer/FooterOne";
import HeaderOne from "../header/HeaderOne";

export default function Price()
{
	return(
		<>
		<HeaderOne/>
		<Breadcrumb title="Price & Plans" subtitle="Responsive & functional IT Design" pagetitle="Pricing" />
		<PriceTableOne/>
		<ContactFormTwo/>
		<FooterOne/>
		</>
	)
}